import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { observer } from 'mobx-react';

const BasicInputTemplate = defaultTemplate(({ field, t, showLabel = true, disabled, style, showRequiredMark = true, showWarning = true, onBlur, onClick, showChangeFlag = false, previousValue = '', toolTipPlace = 'top', isNiko = false, nikoInputData }) => {

    const { placeholder, onChange, ...otherProps } = field.bind();

    const handleChange = (e) => {
        const inputElement = e.target;

        if (onChange) {
            onChange({
                ...e,
                target: { ...inputElement, value: inputElement.value }
            });
        }

    };

    const TooltipContent = observer(({ initianValue, history, fieldName }) => {
        if (!history || history.fieldName !== fieldName) return null;

        const date = new Date(history.eventDate + "Z");
        const formattedDate = date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
        }).replace(',', '');

        return (
        <div>
            <div>Previous: {initianValue ? initianValue : 'blank'}</div>
            <div style={{ fontSize: '11px', opacity: 0.75 }}>
            {history ? history.userName + ', ' + formattedDate : '—'}
            </div>
        </div>)
    });

    const requiredMark = showRequiredMark && field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;

    return (
        <React.Fragment>
            {
                showLabel && (
                    <label className="form__group__label" htmlFor={field.id}>{t(field.label)}{requiredMark}</label>)
            }
            {!showLabel ? requiredMark : null}
            {field.localizedError && showWarning && (
                <div className="validation__message">
                    <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>
                    {field.localizedError}
                </div>
            )}
            <div className='input__wrapper'>
                {showChangeFlag && (
                    isNiko ? 
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id}  place={toolTipPlace} delayShow={600} render={() => 
                        <TooltipContent initianValue={nikoInputData.initialValue} history={nikoInputData.item.history} fieldName={nikoInputData.fieldName} /> }/>
                        <i className="input--change--text opacity-50" data-tooltip-id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id} onMouseEnter={async () => await nikoInputData.getFieldHistory(nikoInputData.item, nikoInputData.fieldName, nikoInputData.currentValue)} data-tooltip-content="" ></i>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id="registerTipItemChanged" place={toolTipPlace} />
                        <i data-tooltip-content={`Previous: ${previousValue ? previousValue : "blank"}`} data-tooltip-id="registerTipItemChanged" className='input--change--text'></i>
                    </React.Fragment>
                )}
                <input
                    className={"input input--base input--text" + (field.touched && !field.isValid && showWarning ? " input--warning" : '')}
                    {...otherProps}
                    onChange={handleChange}
                    disabled={disabled || otherProps.disabled}
                    placeholder={t(placeholder)}
                    style={style}
                    onBlur={onBlur}
                    onClick={onClick}
                />
            </div>

        </React.Fragment>
    )
});

export default BasicInputTemplate;
